import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import {
  ConfigurationContext,
  ConfigurationProvider,
} from "./utils/ConfigurationProvider";
import { PageLoader } from "@components";
import { PostHogProvider } from "posthog-js/react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

// Create a client with basic configuration
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 0, // Always refetch (no caching by default)
      retry: false, // No automatic retries
      refetchOnWindowFocus: false, // Don't refetch on window focus
    },
  },
});

const renderApp = (config) => {
  if (!config) {
    return <PageLoader />;
  }

  const appContent = !config.posthogPublicApiKey ? (
    <App />
  ) : (
    <PostHogProvider
      apiKey={config.posthogPublicApiKey}
      options={{
        api_host: "https://r.ontik.io",
        ui_host: "https://eu.posthog.com",
        capture_pageview: "history_change",
      }}
    >
      <App />
    </PostHogProvider>
  );

  return (
    <QueryClientProvider client={queryClient}>{appContent}</QueryClientProvider>
  );
};

root.render(
  <ConfigurationProvider>
    <ConfigurationContext.Consumer>
      {({ config }) => renderApp(config)}
    </ConfigurationContext.Consumer>
  </ConfigurationProvider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
